export const wysiwygTranslations = {
  en: () => import('@core/prosemirror-legacy/locales/src/en.json').then(t => ({ en: t.default })),
  de: () => import('@core/prosemirror-legacy/locales/src/de.json').then(t => ({ de: t.default })),
  fr: () => import('@core/prosemirror-legacy/locales/src/fr.json').then(t => ({ fr: t.default })),
  nl: () => import('@core/prosemirror-legacy/locales/src/nl.json').then(t => ({ nl: t.default })),
  sv: () => import('@core/prosemirror-legacy/locales/src/sv.json').then(t => ({ sv: t.default })),
  fi: () => import('@core/prosemirror-legacy/locales/src/fi.json').then(t => ({ fi: t.default })),
  es: () => import('@core/prosemirror-legacy/locales/src/es.json').then(t => ({ es: t.default })),
  it: () => import('@core/prosemirror-legacy/locales/src/it.json').then(t => ({ it: t.default })),
  pt: () => import('@core/prosemirror-legacy/locales/src/pt.json').then(t => ({ pt: t.default })),
};
